import { fromJson } from "kreate-common/modules/json-utils";

import { ResourceKey } from "../../types";

import { Params, Result } from "./typing";

export async function httpGet$GetArtwork(url: string) {
  const response = await fetch(url, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  });
  const text = await response.text();
  const data = fromJson(text);
  const result = Result.parse(data);
  return result;
}

export function getResourceKey$GetArtwork(params: Params): ResourceKey {
  return ["72ad7eb0-8192-4b6f-a9bf-04019ba912cf", params];
}
